export { Camera as default } from './Camera';
